import script from "./PromoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PromoCard.vue?vue&type=script&setup=true&lang=js"

import "./PromoCard.vue?vue&type=style&index=0&id=d183196e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d183196e"]])

export default __exports__